<template>
    <a v-if="external"
        :href="route(routeLink)"
        class="group relative inline-flex flex-col items-center py-2 transition-colors duration-300"
        :class="isActive ? colorClasses.activeText : colorClasses.inactiveText"
    >
        <span class="font-medium">{{ title }}</span>

        <span
            class="absolute -bottom-1 left-0 h-[3px] rounded-full transition-all duration-300 ease-out"
            :class="isActive
                ? `w-full opacity-100 ${colorClasses.activeUnderline}`
                : `w-0 opacity-0 group-hover:w-full group-hover:opacity-100 ${colorClasses.hoverUnderline}`"
        />
    </a>

    <Link v-else
        :href="route(routeLink)"
        class="group relative inline-flex flex-col items-center py-2 transition-colors duration-300"
        :class="isActive ? colorClasses.activeText : colorClasses.inactiveText"
    >
        <span class="font-medium">{{ title }}</span>

        <span
            class="absolute -bottom-1 left-0 h-[3px] rounded-full transition-all duration-300 ease-out"
            :class="isActive
                ? `w-full opacity-100 ${colorClasses.activeUnderline}`
                : `w-0 opacity-0 group-hover:w-full group-hover:opacity-100 ${colorClasses.hoverUnderline}`"
        />
    </Link>
</template>

<script>
    import { Link } from '@inertiajs/inertia-vue3'

    export default {
        components: {
            Link
        },

        props: {
            title: String,

            routeLink: String,

            external: {
                type: Boolean,
                default: false
            },

            activePattern: {
                type: String,
                default: null
            },

            color: {
                type: String,
                default: 'sky'
            }
        },

        computed: {
            isActive() {
                return this.activePattern
                    ? route().current(this.activePattern)
                    : route().current(this.routeLink)
            },

            colorClasses() {
                const colors = {
                    sky: {
                        activeText: 'text-sky-400 hover:text-sky-500',
                        inactiveText: 'text-white/80 hover:text-sky-500',
                        activeUnderline: 'bg-sky-400',
                        hoverUnderline: 'group-hover:bg-sky-500'
                    },

                    primaryOrange: {
                        activeText: 'text-primaryOrange hover:text-primaryOrange-300',
                        inactiveText: 'text-white/80 hover:text-primaryOrange-300',
                        activeUnderline: 'bg-primaryOrange',
                        hoverUnderline: 'group-hover:bg-primaryOrange-300'
                    }
                }

                return colors[this.color] || colors.sky
            }
        }
    }
</script>